<template>
  <div class="loader quantum-spinner"></div>
</template>

<style scoped>
/*
The loaders use CSS custom properties (variables) to control the attributes of the loaders
*/
.loader {
  --loader-width: 120px;
  --loader-height: 120px;
  --loader-color-primary: #ffffff;
  --loader-color-secondary: #d1f8ff;
  --line-width: 0.4em;
  --animation-duration: 1.3s;
  --loader-initial-scale: 20;
}

/*.loader,
.loader:before,
.loader:after {
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;
}*/

/*
In order to get optimal results, please only change the 
variables above and don't change anything in the actual loader code
*/
@keyframes momentum {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

.loader.quantum-spinner {
  --primary-circle-offset: calc(
    ((var(--loader-width, 100px) * 0.2) / 2) - var(--line-width, 4px)
  );
  --secondary-circle-offset: calc(
    ((var(--loader-width, 100px) * 0.4) / 2) - var(--line-width, 4px)
  );
  position: relative;
  width: var(--loader-width, 100px);
  height: var(--loader-height, 100px);
  transform-origin: center center;
  border-radius: 50% !important;
  border: var(--line-width, 4px) solid rgba(0, 0, 0, 0) !important;
  border-top-color: var(--loader-color-primary, #33f) !important;
  animation: momentum var(--animation-duration, 1s) linear infinite;
}

.quantum-spinner:before {
  content: "";
  position: absolute;
  transform-origin: center center;
  top: var(--primary-circle-offset, 10px);
  left: var(--primary-circle-offset, 10px);
  width: calc(var(--loader-width, 100px) * 0.8);
  height: calc(var(--loader-height, 100px) * 0.8);
  border-radius: 50% !important;
  border: var(--line-width, 4px) solid rgba(0, 0, 0, 0);
  border-top-color: var(--loader-color-primary, #33f) !important;
  opacity: 0.7;
  filter: hue-rotate(3deg);
  animation: momentum calc(var(--animation-duration, 1s) * 2) linear infinite;
}

.quantum-spinner:after {
  content: "";
  position: absolute;
  top: var(--secondary-circle-offset, 20px);
  left: var(--secondary-circle-offset, 20px);
  width: calc(var(--loader-width, 100px) * 0.6);
  height: calc(var(--loader-height, 100px) * 0.6);
  border-radius: 50% !important;
  transform-origin: center center;
  border: var(--line-width, 4px) solid rgba(0, 0, 0, 0) !important;
  border-top-color: var(--loader-color-primary, #33f) !important;
  opacity: 0.3;
  filter: hue-rotate(6deg);
  animation: momentum var(--animation-duration, 1s) linear infinite;
}
</style>
